import type { FormatStats, FormatTotals } from './member-stats.utils';

interface MemberTeamFormatSummaryProps {
  formatStats: FormatStats[];
  formatTotals: FormatTotals;
}

export default function MemberTeamFormatSummary({ formatStats, formatTotals }: MemberTeamFormatSummaryProps) {
  if (!formatStats) {
    return null;
  }

  const record = formatStats.map((format) => (
    <tr key={`${format.format} - ${format.variation}`}>
      <td>{format.variation ? `${format.format} - ${format.variation}` : format.format}</td>
      <td>{format.played}</td>
      <td>{format.won}</td>
      <td>{format.halved}</td>
      <td>{format.lost}</td>
      <td>{format.points}</td>
    </tr>
  ));

  return (
    <table className="table">
      <thead>
        <tr>
          <th>Format</th>
          <th>Played</th>
          <th>Won</th>
          <th>Halved</th>
          <th>Lost</th>
          <th>Points</th>
        </tr>
      </thead>
      <tbody>{record}</tbody>
      <tfoot style={{ fontWeight: 'bold' }}>
        <tr>
          <td>Total</td>
          <td>{formatTotals.played}</td>
          <td>{formatTotals.won}</td>
          <td>{formatTotals.halved}</td>
          <td>{formatTotals.lost}</td>
          <td>{formatTotals.points}</td>
        </tr>
      </tfoot>
    </table>
  );
}
